import HoleSelectorThree from './HoleSelectorThree'

export default HoleSelectorThree
